import { Grid, Typography, Button } from "@mui/material";
import { Container } from "@mui/system";
import React, { useState, useEffect } from "react";
import globals from "../globals";
import Tooltip from '@mui/material/Tooltip';
import InfoIcon from '@mui/icons-material/Info';
import IconButton from "@mui/material/IconButton";
import { useParams, useNavigate } from "react-router-dom";
import ErrorPage from "../error_page/errorPage";
import { useCart } from "../context/CartContext";

const ChooseCartOrMeetingRequest = () => {
    const { id } = useParams();
    const [showError, setShowError] = useState(false);
    const {cart, addToCart} = useCart();
    const [course, setCourse] = useState(null);

    const navigate = useNavigate();
    useEffect(() => {
        fetch(`${globals.apiUrl}/courses/${id}`, {
            method: 'GET',
            headers: {
                // 'Authorization': `Bearer ${localStorage.getItem('token')}`
                'Content-Type': 'application/json',
            }
        })
        .then(response => response.json())
        .then(data => {
            //console.log(data);
            if (data.detail) {
                setShowError(true);
            }
            setCourse(data);
            //console.log(data);
        })
        .catch(error => {
            console.error('Error:', error);
            setShowError(true);
        });
    }, []);

    const handleGoToCart = (e) => {
        e.preventDefault();
        addToCart(course);
        navigate('/cart');
    }

    return (
        showError ? <ErrorPage /> : 
        <Container>
            <Typography sx={{ color: globals.colors.lightRed, fontSize: 25, fontWeight: 'bold' }}>Избери как да продължиш</Typography>
            <Grid container>
                <Grid item xs={12} sm={8}>
                    <Grid container direction={'column'} spacing={2}>
                        <Grid item>
                            <Grid container sx={{ mt: 4 }}>
                                <Grid item xs={12} sm={7}>
                                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold' }}>1. Заяви безплатна опознавателна среща
                                        <Tooltip sx={{ color: globals.colors.darkBlue }} title="30 минути, в които ще се запознаем и ще обсъдим нуждите ти. Напълно безплатно.">
                                            <IconButton>
                                                <InfoIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Button variant='contained' href={`/request/${id}`} type='submit' size='large' sx={{
                                        ml: 3, backgroundColor: globals.colors.darkBlue, '&:hover': {
                                            backgroundColor: globals.colors.lightBlue,
                                        }, textTransform: 'none', fontWeight: 'bold', width: 160,
                                    }}> Заяви</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid container sx={{ mt: 1 }}>
                                <Grid item xs={12} sm={7}>
                                    <Typography sx={{ color: globals.colors.darkBlue, fontSize: 18, fontWeight: 'bold' }}>2. Продължи към избор на час
                                        <Tooltip sx={{ color: globals.colors.darkBlue }} title="Избери удобен час за урок и премини към плащане.">
                                            <IconButton>
                                                <InfoIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Typography>
                                </Grid>
                                <Grid item xs={12} sm={5}>
                                    <Button variant='contained' href={`/date-time/${id}`} type='submit' size='large' sx={{
                                        ml: 3, backgroundColor: globals.colors.lightRed, '&:hover': {
                                            backgroundColor: globals.colors.darkRed,
                                        }, textTransform: 'none', fontWeight: 'bold', width: 160
                                    }}> Продължи</Button>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={4} sx={{mt:-3}}>
                    <img src='/continue_cart.webp' width={190} height={250} />
                </Grid> 
            </Grid>
        </Container>
        
    );
}

export default ChooseCartOrMeetingRequest